module.exports = __webpack_public_path__ + "static/dolly-p.2671cc2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/dolly-p.jpg
// module id = 476
// module chunks = 35783957827783